import axios from "@/lib/axios";

const getTerminate = (custCode: string | undefined) => {
  return axios.get(`/facility/flat_rates/terminate_cancels/${custCode}/terminate`);
}

export default getTerminate;